import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import {connect} from "react-redux";

import AmountForm from './AmountForm';

class AmountSelector extends Component {
  state = {
    isOpen: false
  };

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.click = this.click.bind(this);
  }

  toggle() {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  }

  click(choice) {
    return () => {
      this.props.onSelect(choice);
    }
  }

  render() {
    if (this.props.system.fixedAmount) {
      return (
        <React.Fragment>
          <strong>{this.props.products.totalAmount}</strong> セット
        </React.Fragment>
      );
    }

    return (
      <Dropdown isOpen={this.state.isOpen} toggle={this.toggle}>
        <DropdownToggle caret>
          <strong>{this.props.products.totalAmount}</strong> セット
        </DropdownToggle>
        <DropdownMenu right className="t-container-amount-form-wrapper">
          <h3>{this.props.products.currentItem.title} / {this.props.products.currentColor.name}</h3>
          <AmountForm/>
        </DropdownMenu>
      </Dropdown>
    );
  }
}

export default connect(f => f, {})(AmountSelector);


// WEBPACK FOOTER //
// ./src/components/Navbar/AmountSelector.js